import { render, staticRenderFns } from "./baiduMap.vue?vue&type=template&id=c28a13f8&"
import script from "./baiduMap.vue?vue&type=script&lang=js&"
export * from "./baiduMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/map/baiduMap.vue"
export default component.exports